import React, { useState } from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import ReusableTable1 from "../../components/table";

interface Column {
  key: string;
  name: string;
  minWidth?: number;
}

const columnsData: Column[] = [
  { key: "name", name: "Name", minWidth: 100 },
  { key: "age", name: "Age", minWidth: 50 },
  { key: "email", name: "Email", minWidth: 150 },
  // Add more columns as needed
];

const initialColumns: Column[] = [
  { key: "name", name: "Name", minWidth: 100 },
];

const data = [
  { name: "John Doe", age: 30, email: "john@example.com" },
  { name: "Jane Smith", age: 25, email: "jane@example.com" },
  // Add more data rows as needed
];

const ParentComponent: React.FC = () => {
  const [columns, setColumns] = useState<Column[]>(initialColumns);

  const handleColumnChange = (event: any) => {
    const value = event.target.value;
    setColumns(columnsData.filter((column) => value.includes(column.key)));
  };

  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 200 }}>
        <InputLabel>Columns</InputLabel>
        <Select
          multiple
          value={columns.map((column) => column.key)}
          onChange={handleColumnChange}
          renderValue={(selected) => selected.join(", ")}
        >
          {columnsData.map((column) => (
            <MenuItem key={column.key} value={column.key}>
              {column.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <ReusableTable1 columns={columns} data={data} />
    </div>
  );
};

export default ParentComponent;
